module.exports = "https://static.cdns.space/tarot-temp/img/strength.316b3bd0.webp";